<template>
  <b-modal
    ref="modal"
    class="secret-question-modal"
    size="lg"
    :title="labels.secretQuestionTitle"
    header-bg-variant="light"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    hide-footer
  >
    <div class="secret-question-description">
      <span>{{ labels.secretQuestionDescription }}</span>
    </div>
    <div v-if="loading" class="loading">
      <Loading />
      <p>{{ labels.loading }}</p>
    </div>
    <b-form v-else @submit.prevent="save">
      <b-form-group>
        <b-form-select
          id="secret-question-form-select"
          class="secret-question-select"
          size="lg"
          required
          @input="changeSecretQuestion($event)"
        >
          <option
            v-for="question in secretQuestions"
            :key="question.id"
            :value="question.id"
          >
            {{ question.label }}
          </option>
        </b-form-select>
        <label for="secret-question-form-select" class="custom-input-label">
          {{ labels.secretQuestion }}
        </label>

        <label class="mdi mdi-chevron-down select-icon"></label>
      </b-form-group>

      <CustomInput
        name="secret-question-answer"
        type="text"
        class="secret-question-answer"
        :label="labels.secretQuestionAnswer"
        @update="setSecretQuestion($event)"
      />
      <footer class="text-right">
        <b-button
          class="btn-save-pass"
          variant="primary"
          type="submit"
          :disabled="submitInProgress"
        >
          <i
            class="mdi mdi-spin pr-2"
            :class="{ 'mdi-loading': submitInProgress }"
          >
          </i>
          {{ labels.confirm }}
        </b-button>
      </footer>
    </b-form>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import CustomInput from '@/components/Shared/Form/CustomInput.vue'
import Loading from '@/components/Shared/Loading.vue'
import { HIGH } from '@/helpers/messages-priority'

export default {
  components: {
    CustomInput,
    Loading,
  },

  data() {
    return {
      loading: false,
      submitInProgress: false,
      secretQuestions: [],
      secretQuestion: undefined,
      secretQuestionAnswer: undefined,
    }
  },
  computed: {
    ...mapGetters(['resources']),
    labels: function() {
      return {
        ...this.resources.page.login.confirmAccount,
        ...this.resources.general.buttons,
      }
    },
  },
  methods: {
    async loadSecretQuestions() {
      this.loading = true
      const { data } = await this.$store.dispatch('user/loadSecretQuestions')

      this.secretQuestions = data
      this.loading = false
    },

    changeSecretQuestion(value) {
      this.secretQuestion = value
    },

    setSecretQuestion(event) {
      this.secretQuestionAnswer = event.value
    },

    save() {
      this.$store
        .dispatch('users/changeSecretQuestion', {
          secretQuestion: this.secretQuestion,
          secretQuestionAnswer: this.secretQuestionAnswer,
        })
        .then(() => {
          this.$root.$emit('app:message:show', {
            priority: HIGH,
            text: this.resources.page.home.users.edit.saveWithSuccessMessage,
            status: 'success',
          })
        })
        .catch(() => {
          this.$root.$emit('app:message:show', {
            priority: HIGH,
            text: this.resources.page.home.users.edit.errorMessage,
            status: 'danger',
          })
        })
        .finally(() => {
          this.submitInProgress = false
          this.$refs.modal.hide()
        })
    },

    open() {
      this.loadSecretQuestions()
      this.$refs.modal.show()
    },

    hide() {
      this.$refs.modal.hide()
    },

    validate() {},
  },
}
</script>

<style lang="scss">
@import '~@/styles/custom/colors';

.btn-save-pass {
  margin-top: 25px;
  min-width: 150px;
}

.secret-question-select {
  cursor: pointer;
}

.secret-question-description {
  padding-bottom: 1rem !important;
}

.secret-question-answer {
  padding-top: 1rem !important;
}

.select-icon {
  top: 2px !important;
  right: 6px !important;
}

.custom-input-label {
  font-size: 12px !important;
  color: map-get($theme-colors, 'gray03') !important;
  top: -18px !important;
}
</style>
